<template src="./Category.html"></template>
<style lang="scss" scoped src="./Category.scss"></style>

<script>

import Api from "@/api/Api";
import {OrkLoader, OrkProductCart} from "@/components/Ork";
import {
    SfSidebar,
    SfScrollable,
    SfRange,
    SfRadio,
    SfCheckbox,
    SfNotification,
    SfPagination,
    SfBreadcrumbs,
    SfDivider,
    SfHeading,
    SfSelect,
    SfButton,
    SfImage,
    SfIcon,
    SfFilter,
    SfLink,
    SfAccordion,
    SfBar
} from '@storefront-ui/vue';
import ProductOptions from "@/utils/product_options";
import {LightProduct} from "@/models/product";
import {Pagination} from "@/models/pagination";
import icons from "@/utils/icons";

export default {
    name: 'Category',

    data() {
        return {
            scrollPosition: null,
            products: null,
            loading: false,
            error: null,
            pagination: Pagination.of(null),
            sortBy: {
                options: ProductOptions.getProductOptions.sortAttributes,
                selected: process.env.VUE_APP_DEFAULT_SORT
            },
            sortOption: ProductOptions.getProductOptions.sortAttributes,
            breadcrumbs: [],
            filters: null,
            selectedFilters: [],
            currentFilters: null,
            icons: icons,
            childrenCategory: [],
            filteredPrice: [],
            isFilterSidebarOpen: false,
            marketing: null,
            marketingSEO: null,
            marketingHeader: null,
            loadingMarketing: false,
            openedFilter: []
        };
    },
    components: {
        SfSidebar,
        SfBar,
        SfScrollable,
        SfLink,
        SfRadio,
        SfAccordion,
        SfRange,
        SfFilter,
        OrkProductCart,
        SfHeading,
        SfBreadcrumbs,
        SfNotification,
        SfPagination,
        SfButton,
        SfImage,
        SfCheckbox,
        SfIcon,
        SfSelect,
        OrkLoader,
        SfDivider
    },
    computed: {
        customer() {
            return this.$store.getters.getProfile;
        },
        categoryTree: {
            get() {
                return this.$store.getters.getCategoryTree
            }
        },
        firstLevelCategoryPaths: {
            get() {
                return this.$store.getters.getCategoryTree?.children?.map(lev1Child => lev1Child.path)
            }
        },
        activeCategory: {
            get() {
                return this.$store.getters.activeCategory(this.$route.params.level3 || this.$route.params.level2 || this.$route.params.level1);
            },
            set(value) {
                if (!value) {
                    this.$router.push('/404')
                }
            }
        }
    },
    watch: {
        customer() {
            if (this.activeCategory) {
                if (!this.$router.history.current.query.filters) {
                    this.removeFilters(true)
                }
                this.setBreadcrumbs(this.$route.params);
                this.getCategoryMarketing(this.activeCategory)
                this.fetchProducts(this.activeCategory);
            }
        },
        categoryTree() {
            this.setBreadcrumbs(this.$route.params)
            this.activeCategory = this.$store.getters.activeCategory(this.$route.params.level3 || this.$route.params.level2 || this.$route.params.level1)
        },

        activeCategory: {
            handler(newCat, oldCat) {
                if (this.categoryTree) {
                    if (oldCat) {
                        if (newCat) {
                            if (newCat.path !== oldCat.path) {
                                if (!this.$router.history.current.query.filters) {
                                    this.removeFilters(true)
                                }
                                if (!this.$router.history.current.query.sort) {
                                    this.sortBy.selected = process.env.VUE_APP_DEFAULT_SORT
                                }
                                this.setBreadcrumbs(this.$route.params)
                                this.getCategoryMarketing(newCat)
                                this.fetchProducts(newCat);
                            } else {
                                this.fetchProducts(newCat);
                            }
                        } else {
                            // this.$router.push('/404')
                        }
                    } else {
                        if (newCat) {
                            if (!this.$router.history.current.query.filters) {
                                this.removeFilters(true)
                            }
                            if (!this.$router.history.current.query.sort) {
                                this.sortBy.selected = process.env.VUE_APP_DEFAULT_SORT
                            }
                            this.setBreadcrumbs(this.$route.params)
                            this.getCategoryMarketing(newCat)
                            this.fetchProducts(newCat);
                        } else {
                            //this.$router.push('/404')
                        }
                    }
                }
            }, immediate: true
        }
    },
    mounted() {

        window.addEventListener('scroll', this.updateScroll);
        if (!window['disable-facebook']) {
            fbq('track', "ViewContent");
        }
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.updateScroll);
    },
    methods: {
        updateScroll() {
            this.scrollPosition = window.scrollY;
            if (this.scrollPosition > 30) {
                document.body.classList.add("notTop");
            } else {
                document.body.classList.remove("notTop");
            }
        },

        changeCategory() {
            this.getCategoryMarketing(this.activeCategory)
        }
        ,
        getCategoryMarketing(activeCategory) {
            if (activeCategory) {
                let rootCateg = this.firstLevelCategoryPaths
                this.marketing = null
                const descEl = document.querySelector('head meta[name="description"]');
                const titleEl = document.querySelector('head title');

                this.loadingMarketing = true;
                Api.marketing.getCategory(activeCategory.path)
                    .then(data => {
                        if (rootCateg.includes(activeCategory.path)) {
                            this.marketingHeader = data.header ? data.header : null;
                        } else {
                            this.marketingHeader = null
                        }
                        this.marketingSEO = data.seo ? data.seo : null
                    }).catch((e) => {
                    this.marketingHeader = null;
                    console.error(e);
                }).finally(() => {
                    if (this.marketingSEO) {
                        descEl.setAttribute('content', this.marketingSEO.description);
                        titleEl.textContent = this.marketingSEO.title;
                    } else {
                        descEl.setAttribute('content', this.$i18n.t('seo.categoryDescription', {categoryName: activeCategory.label}));
                        titleEl.textContent = activeCategory.label + ' | Air France Shopping';
                    }
                    this.loadingMarketing = false;
                })
            } else {
                this.$router.push('/404')
            }
        }
        ,
        getChildCategory(activeCategory) {
            if (activeCategory && activeCategory.children && activeCategory.children.length > 0) {
                let children = [...activeCategory.children]
                this.childrenCategory = children.sort(function (a, b) {
                        return a.label.localeCompare(b.label)
                    }
                )

            } else {
                this.childrenCategory = [];
            }
        }
        ,
        isDisabled(filter, value) {
            /*
            if (this.currentFilters.length > 0) {
              let selected = this.currentFilters.find(f => f.filterName === filter.filterName && f.values.find(val => val === value))
              if (selected) {
                return false;
              }
            }*/
            return false
        }
        ,
        changeFilterPrice(filter, fetch) {
            let minPrice = Math.floor(Number(filter.value[0].replace(/\D+/g, '')))
            let maxPrice = Math.ceil(Number(filter.value[1].replace(/\D+/g, '')))
            let isExist = this.selectedFilters.find(f => f.filterName === filter.filterName)
            let filterValue = '[>=' + minPrice + '||<=' + maxPrice + ']'
            if (!isExist) {

                this.selectedFilters.push({
                    filterName: filter.filterName,
                    value: filterValue,
                    label: filter.label,
                    type: filter.type,
                    min: minPrice,
                    max: maxPrice
                });

            } else {
                this.selectedFilters.map(f => {
                    if (f.filterName === filter.filterName) {
                        f.value = filterValue,
                            f.min = minPrice,
                            f.max = maxPrice
                    }
                })
            }
            this.filteredPrice = [minPrice, maxPrice];
            if (!fetch) {
                this.routerAddFilter();
            }
        }
        ,
        changeFilterMulti(filter, fetch) {
            if (this.selectedFilters.length > 0) {
                let isExist = this.selectedFilters.find(f => f.filterName === filter.filterName)
                if (!isExist) {
                    if (Array.isArray(filter.value)) {
                        this.selectedFilters.push({
                            filterName: filter.filterName,
                            label: filter.label,
                            type: filter.type,
                            value: filter.value
                        });
                    } else {
                        this.selectedFilters.push({
                            filterName: filter.filterName,
                            label: filter.label,
                            type: filter.type,
                            value: [filter.value]
                        });
                    }
                    if (!fetch)
                        this.routerAddFilter();
                    return;
                }
                this.selectedFilters.map(f => {
                    if (f.filterName === filter.filterName) {
                        if (Array.isArray(filter.value)) {
                            filter.value.map((entry) => {
                                if (!f.value.includes(entry)) {          //checking weather array contain the value
                                    f.value.push(entry);               //adding to array because value doesnt exists
                                }
                            })
                        } else {
                            if (!f.value.includes(filter.value)) {          //checking weather array contain the value
                                f.value.push(filter.value);               //adding to array because value doesnt exists
                            } else {
                                f.value.splice(f.value.indexOf(filter.value), 1);  //deleting
                            }
                        }
                    }
                    if (f.value.length === 0) {
                        this.selectedFilters.splice(this.selectedFilters.indexOf(f), 1)
                    }
                })
            } else {
                if (Array.isArray(filter.value)) {
                    this.selectedFilters.push({
                        filterName: filter.filterName,
                        label: filter.label,
                        type: filter.type,
                        value: filter.value
                    });
                } else {
                    this.selectedFilters.push({
                        filterName: filter.filterName,
                        label: filter.label,
                        type: filter.type,
                        value: [filter.value]
                    });
                }
            }
            if (!fetch)
                this.routerAddFilter();
        }
        ,
        changeFilterEnum(filter, fetch) {
            if (this.selectedFilters.length > 0) {
                let isExist = this.selectedFilters.find(f => f.filterName === filter.filterName)
                if (!isExist) {
                    this.selectedFilters.push({
                        filterName: filter.filterName,
                        label: filter.label,
                        type: filter.type,
                        value: filter.value
                    })
                    return;
                }
                this.selectedFilters.map(f => {
                    if (f.filterName === filter.filterName) {
                        f.value = filter.value
                    }
                })
            } else {
                this.selectedFilters.push({
                    filterName: filter.filterName,
                    label: filter.label,
                    type: filter.type,
                    value: filter.value
                })
            }
            if (!fetch)
                this.routerAddFilter();
        }
        ,
        removeFilters(fetch) {
            this.selectedFilters = [];
            this.filteredPrice = [];

            if (!fetch) {
                this.routerAddFilter();
            } else {
                this.$router.replace({
                    query: null
                }).catch(() => {

                })
            }
        }
        ,
        removeFilter(filterToRemove) {
            if (filterToRemove.filterName === 'price') {
                this.filteredPrice = []
            }
            const index = this.selectedFilters.indexOf(filterToRemove);
            if (index > -1) {
                this.selectedFilters.splice(index, 1);
            }

            this.routerAddFilter();
        }
        ,
        removeFilterSingle(filterToRemove, value) {
            this.selectedFilters.map(selectFilter => {
                if (selectFilter.filterName === filterToRemove.filterName) {
                    if (selectFilter.value.length > 0) {
                        if (selectFilter.value.includes(value)) {
                            selectFilter.value.splice(selectFilter.value.indexOf(value), 1);
                            if (selectFilter.value.length === 0) {
                                const index = this.selectedFilters.indexOf(filterToRemove);
                                if (index > -1) {
                                    this.selectedFilters.splice(index, 1);
                                }
                            }
                        }
                    }
                }
            })
            this.routerAddFilter();
        },
        getSelectedFilter(filter) {
            if (this.selectedFilters) {
                return this.selectedFilters.find(selectFilter => selectFilter.name === filter.name)
            }
        },
        formatArrayValue(value) {
            return '"' + value.join('"||"') + '"';
        }
        ,
        routerAddFilter() {
            let sort = this.$router.history.current.query.sort;
            let page = this.$router.history.current.query.page;
            let itemsPerPage = this.$router.history.current.query.itemsPerPage;
            let filterQuery = '';
            if (this.selectedFilters.length > 0) {

                this.selectedFilters.forEach(function (filter, index, array) {

                    if (index === array.length - 1) {

                        //const toto = filter.value.map(val => val.replace(',', '||'))
                        if (filter.type === "MULTISELECT") {
                            filterQuery += filter.filterName + ':' + '[' + filter.value.join('||') + ']'
                        } else {
                            filterQuery += filter.filterName + ':' + filter.value
                        }
                    } else {
                        if (filter.type === "MULTISELECT") {
                            filterQuery += filter.filterName + ':' + '[' + filter.value.join('||') + ']' + '&'
                        } else {
                            filterQuery += filter.filterName + ':' + filter.value + '&'
                        }
                    }
                })

                this.$router.replace({
                    hash: "productsList",
                    query: {
                        filters: filterQuery,
                        sort: sort,
                        itemsPerPage: itemsPerPage
                    }
                }).catch(() => {

                })
            } else {
                this.$router.replace({
                    hash: "productsList",
                    query: {filters: null, sort: sort, page: page, itemsPerPage: itemsPerPage}
                }).catch(() => {

                })
            }
        }
        ,
        isSelectedEnum(filter) {

            if (this.selectedFilters.length > 0) {
                let selected = this.selectedFilters.find(f => f.filterName === filter.filterName && f.value === filter.value)
                if (selected) {
                    return selected.value;
                }
            }
        }
        ,
        isSelectedMulti(filter) {
            if (this.selectedFilters.length > 0) {
                let selected = this.selectedFilters.find(f => f.filterName === filter.filterName && f.value?.find(val => val === filter.value))
                if (selected) {
                    return true;
                }
            }
        }
        ,
        setBreadcrumbs(params) {
            let breadcrumbs = [{
                text: this.$t('Home'),
                link: '/'
            }];
            let level1 = null,
                level2 = null,
                level3 = null;

            if (params.level1) {
                const catlevel1 = this.categoryTree.children.find(categ => categ.slug === params.level1)
                if (catlevel1) {
                    level1 = {text: catlevel1.label, link: '/categorie/' + catlevel1.slug}
                    breadcrumbs.push(level1)
                }
                if (params.level2) {
                    const catlevel2 = this.categoryTree.children.find(categ => categ.slug === params.level1).children.find(categlvl2 => categlvl2.slug === params.level2)
                    if (catlevel2 && level1) {
                        level2 = {text: catlevel2.label, link: level1.link + '/' + catlevel2.slug}
                        breadcrumbs.push(level2)
                    }
                }

                if (params.level3) {
                    const catlevel3 = this.categoryTree.children.find(categ => categ.slug === params.level1).children.find(categlvl2 => categlvl2.slug === params.level2).children.find(categlvl3 => categlvl3.slug === params.level3)
                    if (catlevel3 && level2) {
                        level3 = {text: catlevel3.label, link: level2.link + '/' + catlevel3.slug}
                        breadcrumbs.push(level3)
                    }
                }
                this.breadcrumbs = breadcrumbs

            }
        }
        ,
        changeSorting(sort) {

            this.sortBy.selected = sort;
            ProductOptions.changeSorting(sort);
        }
        ,
        changeItemsPerPage(itemsPerPage) {
            this.pagination.itemsPerPage = itemsPerPage;
            ProductOptions.changeItemsPerPage(itemsPerPage);
        }
        ,
        fetchProducts(activeCategory) {
            if (activeCategory) {
                this.loading = true;
                let content = [];
                this.getChildCategory(activeCategory)


                Api.product.getByCategory(activeCategory.path, this.$router.history.current.query)
                    .then(data => {
                        if (data?.products) {
                            this.pagination = Pagination.of(data.products);
                            for (let lightProduct of data.products.content) {
                                content.push(LightProduct.of(lightProduct));
                            }

                            if (data.filterableAttributes) {
                                let currentFilters = Object.fromEntries(
                                    Object.entries({...data.filterableAttributes}).sort(([keyA, a], [keyB, b]) => {

                                        if (keyA === "afs_details_scale") {
                                            a.values.sort((a, b) => b.substring(2) - a.substring(2));
                                        } else {
                                            a.values.sort(function (a, b) {
                                                return a.localeCompare(b)
                                            });
                                        }

                                        if (keyB === "afs_details_scale") {
                                            b.values.sort((a, b) => b.substring(2) - a.substring(2));
                                        } else {
                                            b.values.sort(function (a, b) {
                                                return a.localeCompare(b)
                                            });
                                        }

                                        return a.label < b.label ? -1 : 1;
                                    })
                                );
                                this.currentFilters = Object.keys(currentFilters).map((key) => currentFilters[key])
                            }

                            if (data.filterableAttributes) {
                                this.filters = Object.fromEntries(
                                    Object.entries({...data.filterableAttributes}).sort(([keyA, a], [keyB, b]) => {

                                        if (keyA === "afs_details_scale") {
                                            a.values.sort((a, b) => b.substring(2) - a.substring(2));
                                        } else {
                                            a.values.sort(function (a, b) {
                                                return a.localeCompare(b)
                                            });
                                        }

                                        if (keyB === "afs_details_scale") {
                                            b.values.sort((a, b) => b.substring(2) - a.substring(2));
                                        } else {
                                            b.values.sort(function (a, b) {
                                                return a.localeCompare(b)
                                            });
                                        }

                                        return a.label < b.label ? -1 : 1;
                                    }).sort(([keyA, a], [keyB, b]) => {
                                        if (keyA === "price" || keyB === "price") {
                                            this.openedFilter = [a.label]
                                            return -1
                                        }
                                    })
                                );

                            }
                            if (this.$router.history.current.query.filters) {
                                let filtersQuery = this.$router.history.current.query.filters.split('&');
                                let hasPrice = false;
                                const openedFilter = []


                                filtersQuery.map(f => {

                                    let label = f.slice(0, f.indexOf(':'));
                                    let value = f.slice(f.indexOf(':') + 1, f.length);
                                    let val = [label, value]
                                    let filter = {}

                                    filter = {
                                        label: this.filters[val[0]].label,
                                        type: this.filters[val[0]].filterType,
                                        filterName: val[0],
                                    };
                                    openedFilter.push(filter.label)
                                    switch (this.filters[val[0]].filterType) {
                                        case "MULTISELECT":
                                            filter = {
                                                label: this.filters[val[0]].label,
                                                type: this.filters[val[0]].filterType,
                                                filterName: val[0],
                                                value: val[1].replaceAll(/\]|\[/gmi, '').split('||')
                                            };
                                            this.changeFilterMulti(filter, true)
                                            break;
                                        case"ENUMERATION":
                                            filter = {
                                                label: this.filters[val[0]].label,
                                                type: this.filters[val[0]].filterType,
                                                filterName: val[0],
                                                value: val[1]
                                            };
                                            this.changeFilterEnum(filter, true)
                                            break;
                                        case "RANGE":
                                            if (filter.filterName === 'price') {
                                                this.filteredPrice = val[1].replaceAll(/<|>|=|\]|\[/gmi, '').split('||');
                                                filter = {
                                                    label: this.filters[val[0]].label,
                                                    type: this.filters[val[0]].filterType,
                                                    filterName: val[0],
                                                    value: [this.filteredPrice[0], this.filteredPrice[1]],
                                                    min: this.filteredPrice[0],
                                                    max: this.filteredPrice[1]
                                                }

                                                hasPrice = true
                                                this.changeFilterPrice(filter, true)
                                            }
                                            break;
                                    }
                                })
                                this.openedFilter = openedFilter
                                if (!hasPrice) {
                                    this.filteredPrice = []
                                }
                            } else {
                                //this.openedFilter = []
                            }


                        }
                    })
                    .catch((e) => {
                        console.error(e)
                        this.$store.dispatch('sendNotification', {
                            type: 'danger',
                            message: this.$i18n.t('errors.server.access'),
                            icon: icons.error
                        });
                    }).finally(() => {
                    this.products = content;
                    this.loading = false;

                })
            } else {
                this.$router.push('/404')
            }
        }
    }
}

</script>

